import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
import {
  MutableLocationBaseFieldsFragmentDoc,
  WorkflowLocationRestrictionFieldsFragmentDoc,
} from './LocationType.generated'
const defaultOptions = {}
export type IGetOffloadingEquipmentQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  attributeType: Types.LocationType
}>

export type IGetOffloadingEquipmentQuery = {
  locations?: {
    data: Array<
      | {
          id?: any | null
          name: string
          isDeleted: boolean
          type?: Types.LocationType | null
          createdAt?: any | null
          updatedAt?: any | null
          color: string
          iconName: string
          code?: string | null
          stxResourceId?: string | null
          permittedCompanies?: Array<any | null> | null
          isBookable: boolean
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          name: string
          isDeleted: boolean
          type?: Types.LocationType | null
          createdAt?: any | null
          updatedAt?: any | null
          color: string
          iconName: string
          code?: string | null
          stxResourceId?: string | null
          permittedCompanies?: Array<any | null> | null
          isBookable: boolean
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          name: string
          isDeleted: boolean
          type?: Types.LocationType | null
          createdAt?: any | null
          updatedAt?: any | null
          color: string
          iconName: string
          code?: string | null
          stxResourceId?: string | null
          permittedCompanies?: Array<any | null> | null
          isBookable: boolean
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          name: string
          isDeleted: boolean
          type?: Types.LocationType | null
          createdAt?: any | null
          updatedAt?: any | null
          color: string
          iconName: string
          code?: string | null
          stxResourceId?: string | null
          permittedCompanies?: Array<any | null> | null
          isBookable: boolean
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          name: string
          isDeleted: boolean
          type?: Types.LocationType | null
          createdAt?: any | null
          updatedAt?: any | null
          color: string
          iconName: string
          code?: string | null
          stxResourceId?: string | null
          permittedCompanies?: Array<any | null> | null
          isBookable: boolean
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          name: string
          isDeleted: boolean
          type?: Types.LocationType | null
          createdAt?: any | null
          updatedAt?: any | null
          color: string
          iconName: string
          code?: string | null
          stxResourceId?: string | null
          permittedCompanies?: Array<any | null> | null
          isBookable: boolean
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          name: string
          isDeleted: boolean
          type?: Types.LocationType | null
          createdAt?: any | null
          updatedAt?: any | null
          color: string
          iconName: string
          code?: string | null
          stxResourceId?: string | null
          permittedCompanies?: Array<any | null> | null
          isBookable: boolean
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          name: string
          isDeleted: boolean
          type?: Types.LocationType | null
          createdAt?: any | null
          updatedAt?: any | null
          color: string
          iconName: string
          code?: string | null
          stxResourceId?: string | null
          permittedCompanies?: Array<any | null> | null
          isBookable: boolean
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          name: string
          isDeleted: boolean
          type?: Types.LocationType | null
          createdAt?: any | null
          updatedAt?: any | null
          color: string
          iconName: string
          code?: string | null
          stxResourceId?: string | null
          permittedCompanies?: Array<any | null> | null
          isBookable: boolean
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          name: string
          isDeleted: boolean
          type?: Types.LocationType | null
          createdAt?: any | null
          updatedAt?: any | null
          color: string
          iconName: string
          code?: string | null
          stxResourceId?: string | null
          permittedCompanies?: Array<any | null> | null
          isBookable: boolean
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          parent?: { parentId?: any | null } | null
        }
      | {
          templateId?: string | null
          data?: any | null
          showInMap: boolean
          accessibleLevels?: Array<any | null> | null
          rollups?: any | null
          id?: any | null
          name: string
          isDeleted: boolean
          type?: Types.LocationType | null
          createdAt?: any | null
          updatedAt?: any | null
          color: string
          iconName: string
          code?: string | null
          stxResourceId?: string | null
          permittedCompanies?: Array<any | null> | null
          isBookable: boolean
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          linkedSensor?: {
            id?: any | null
            name: string
            infuseId?: string | null
            data?: any | null
          } | null
          effectivePosition?: {
            source: Types.PositionSource
            latitude?: number | null
            longitude?: number | null
            lastUpdatedAt?: any | null
          } | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          name: string
          isDeleted: boolean
          type?: Types.LocationType | null
          createdAt?: any | null
          updatedAt?: any | null
          color: string
          iconName: string
          code?: string | null
          stxResourceId?: string | null
          permittedCompanies?: Array<any | null> | null
          isBookable: boolean
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          name: string
          isDeleted: boolean
          type?: Types.LocationType | null
          createdAt?: any | null
          updatedAt?: any | null
          color: string
          iconName: string
          code?: string | null
          stxResourceId?: string | null
          permittedCompanies?: Array<any | null> | null
          isBookable: boolean
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          name: string
          isDeleted: boolean
          type?: Types.LocationType | null
          createdAt?: any | null
          updatedAt?: any | null
          color: string
          iconName: string
          code?: string | null
          stxResourceId?: string | null
          permittedCompanies?: Array<any | null> | null
          isBookable: boolean
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          name: string
          isDeleted: boolean
          type?: Types.LocationType | null
          createdAt?: any | null
          updatedAt?: any | null
          color: string
          iconName: string
          code?: string | null
          stxResourceId?: string | null
          permittedCompanies?: Array<any | null> | null
          isBookable: boolean
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          name: string
          isDeleted: boolean
          type?: Types.LocationType | null
          createdAt?: any | null
          updatedAt?: any | null
          color: string
          iconName: string
          code?: string | null
          stxResourceId?: string | null
          permittedCompanies?: Array<any | null> | null
          isBookable: boolean
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          name: string
          isDeleted: boolean
          type?: Types.LocationType | null
          createdAt?: any | null
          updatedAt?: any | null
          color: string
          iconName: string
          code?: string | null
          stxResourceId?: string | null
          permittedCompanies?: Array<any | null> | null
          isBookable: boolean
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          parent?: { parentId?: any | null } | null
        }
    >
  } | null
}

export const GetOffloadingEquipmentDocument = gql`
  query GetOffloadingEquipment(
    $projectId: ObjectId!
    $attributeType: LocationType!
  ) {
    locations(
      projectId: $projectId
      attributeType: $attributeType
      offset: 0
      limit: 1000000
    ) {
      data {
        id
        name
        isDeleted
        type
        createdAt
        updatedAt
        ...MutableLocationBaseFields
        workflowRestrictions {
          maxBookingDurations {
            ...WorkflowLocationRestrictionFields
          }
          maxOverlappingBookings {
            ...WorkflowLocationRestrictionFields
          }
        }
        ... on OffloadingEquipment {
          templateId
          data
          showInMap
          accessibleLevels
          rollups
          linkedSensor {
            id
            name
            infuseId
            data
          }
          effectivePosition {
            source
            latitude
            longitude
            lastUpdatedAt
          }
        }
      }
    }
  }
  ${MutableLocationBaseFieldsFragmentDoc}
  ${WorkflowLocationRestrictionFieldsFragmentDoc}
`

/**
 * __useGetOffloadingEquipmentQuery__
 *
 * To run a query within a React component, call `useGetOffloadingEquipmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOffloadingEquipmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOffloadingEquipmentQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      attributeType: // value for 'attributeType'
 *   },
 * });
 */
export function useGetOffloadingEquipmentQuery(
  baseOptions: Apollo.QueryHookOptions<
    IGetOffloadingEquipmentQuery,
    IGetOffloadingEquipmentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IGetOffloadingEquipmentQuery,
    IGetOffloadingEquipmentQueryVariables
  >(GetOffloadingEquipmentDocument, options)
}
export function useGetOffloadingEquipmentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetOffloadingEquipmentQuery,
    IGetOffloadingEquipmentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IGetOffloadingEquipmentQuery,
    IGetOffloadingEquipmentQueryVariables
  >(GetOffloadingEquipmentDocument, options)
}
export type GetOffloadingEquipmentQueryHookResult = ReturnType<
  typeof useGetOffloadingEquipmentQuery
>
export type GetOffloadingEquipmentLazyQueryHookResult = ReturnType<
  typeof useGetOffloadingEquipmentLazyQuery
>
export type GetOffloadingEquipmentQueryResult = Apollo.QueryResult<
  IGetOffloadingEquipmentQuery,
  IGetOffloadingEquipmentQueryVariables
>
